import React from "react";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
} from "chart.js";
import { Bar } from "react-chartjs-2";
import Colors from "../../../../../themes/Colors";

ChartJS.register(CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend);

const AudienceBarChart = ({ labels, values, axisTitle }) => {
  const data = {
    labels,
    datasets: [
      {
        data: values,
        backgroundColor: Colors.primary,
        borderRadius: 4,
        maxBarThickness: 42,
      },
    ],
  };

  const options = {
    responsive: true,
    maintainAspectRatio: false,
    scales: {
      y: {
        beginAtZero: true,
        title: { display: !!axisTitle, text: axisTitle },
      },
      x: {
        beginAtZero: true,
        grid: { display: false },
      },
    },
    plugins: { legend: { display: false } },
  };

  return (
    <div className="audienceChart__canvas">
      <Bar data={data} options={options} />
    </div>
  );
};

export default AudienceBarChart;
